import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {NavigationEnd, Router} from "@angular/router";
import {AppComponent} from "../../app.component";
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {EmailRegex, MustMatch, PasswordRegex} from "../../const/utils";
import {User} from "../../models/user.model";
import {Civility} from "../../enums/civility";
import {AccountFormFields} from "../../enums/form-fields";
import {RouterLinks} from "../../enums/router-links";
import {ModalTypes} from "../../enums/modal-types";
import {ModalTemplates} from "../../enums/modal-templates";

@Component({
  selector: 'app-account',
  templateUrl: './account.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./account.component.less']
})
export class AccountComponent implements OnInit {
  userForm!: FormGroup;
  submitted = false;
  global_texts: any = null;
  pathname: string = "";
  is_create_account_page: boolean = false;
  title: string = "";
  civilities = Civility;
  userIdLoggedIn: boolean = false;
  user!: User;

  constructor(
    public app: AppComponent,
    private formBuilder: FormBuilder,
    private router: Router,
  ) {
    // this.router.events.subscribe((event) => {
    //   if (event instanceof NavigationEnd) {
    //     this.initializeComponent();
    //   }
    // });
  }

  ngOnInit(): void {
    this.initializeComponent();
  }

  initializeComponent() {
    // Check if there is a logged user
    this.userIdLoggedIn = !!sessionStorage.getItem('session_token');
    console.log("this.userIdLoggedIn ==> ", this.userIdLoggedIn);
    // Get the global texts
    this.app.sharedHelper.getGlobalTexts().subscribe((texts: any) => {
      this.global_texts = texts;

      // Get the title switch the page
      this.pathname = window.location.pathname;
      this.is_create_account_page = this.pathname === "/" + RouterLinks.CreateAccount;
      this.title = this.is_create_account_page ? this.global_texts.create_account_page.title : this.global_texts.my_account_page.title;

      // Create the form
      this.userForm = this.formBuilder.group({});

      let account_form_fields =
        !this.userIdLoggedIn
          ? AccountFormFields.filter(field => field.pages.indexOf(RouterLinks.CreateAccount) !== -1)
          : AccountFormFields.filter(field => field.pages.indexOf(RouterLinks.MyAccount) !== -1);

      account_form_fields.forEach(field => {
        //console.log("field ==> ", field)
        let control: FormControl;

        if (field.param.indexOf('password') !== -1) {
          control = new FormControl('', [Validators.required, Validators.pattern(PasswordRegex)]);
        } else if (field.param === 'email') {
          control = new FormControl('', [Validators.required, Validators.pattern(EmailRegex)]);
        } else if (field.param === 'accept_terms') {
          control = new FormControl('', [Validators.requiredTrue]);
        } else if (field.param === 'office_name') {
          control = new FormControl('');
        } else if (field.param === 'accept_newsletter') {
          control = new FormControl(false);
        } else {
          control = new FormControl('', Validators.required);
        }

        this.userForm.addControl(field.param, control);

      });

      if (!this.userIdLoggedIn)
        this.userForm.setValidators(MustMatch('password', 'confirm_password'));

      // If the user is logged in, get the user data
      if (this.userIdLoggedIn) {
        this.userForm.get('id_rpps')?.disable();

        // Get the user data
        this.app.apiService.getUser().subscribe((response: any) => {
          console.log("getUser response ==> ", response);
          this.user = response?.data;
          //console.log("this.user ==> ", this.user);

          //Set the form values to the user data
          Object.keys(this.userForm.controls).forEach(key => {
            if (this.user[key]) {
              this.userForm.controls[key].setValue(this.user[key]);
            }
          });
        });
      }
    });
  }

  getFormField(controlName: string): any {
    return AccountFormFields.find(field => field.param === controlName);
  }

  onSubmit() {
    // Display the form values
    console.log("this.loginForm.value ==> ", this.userForm.value);
    this.submitted = true;

    // Stop here if form is invalid
    if (this.userForm.invalid) return;

    let userToEdit = this.userForm.value;
    //if (this.userIdLoggedIn) delete userToEdit.id_rpps;
    delete userToEdit.confirm_password;

    // Call signup user method
    if (this.userIdLoggedIn) this.editUser(userToEdit);
    else this.saveUser(this.userForm.value);
  }

  editUser(_user: User) {
    console.log("editUser _user ==> ", _user)
    this.app.apiService.editUser(_user).subscribe((response: any) => {
      console.log("editUser response ==> ", response);
      if (response?.data) {
        // Show modal with success message
        this.app.dialogService.confirmThis('', this.global_texts.modals?.user_edited?.message, ModalTypes.Alert, ModalTemplates.Default, () => {this.initializeComponent();}, () => {});
      }
    });
  }

  saveUser(_user: User) {
    this.app.apiService.addUser(_user).subscribe((response: any) => {
      console.log("response ==> ", response);
      if (response?.data) {
        // Show modal with success message
        this.app.dialogService.confirmThis('', this.global_texts.modals?.user_created?.message, ModalTypes.Alert, ModalTemplates.Default, () => {
          // Redirect to login
          this.router.navigate([RouterLinks.Login]);
        }, () => {});
      }
    });
  }

  protected readonly Object = Object;
  protected readonly RouterLinks = RouterLinks;
}
